import React from "react";

const HomeSvg = ({ fill }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.15721 19.7714V16.7047C7.1572 15.9246 7.79312 15.2908 8.58101 15.2856H11.4671C12.2587 15.2856 12.9005 15.9209 12.9005 16.7047V19.7809C12.9003 20.4432 13.4343 20.9845 14.103 21H16.0271C17.9451 21 19.5 19.4607 19.5 17.5618V8.83784C19.4898 8.09083 19.1355 7.38935 18.538 6.93303L11.9577 1.6853C10.8049 0.771566 9.1662 0.771566 8.01342 1.6853L1.46203 6.94256C0.862259 7.39702 0.507387 8.09967 0.5 8.84736V17.5618C0.5 19.4607 2.05488 21 3.97291 21H5.89696C6.58235 21 7.13797 20.4499 7.13797 19.7714"
        stroke={fill === "none" && "#718596"}
        stroke-linecap={fill === "none" && "round"}
        stroke-linejoin={fill === "none" && "round"}
      />
    </svg>
  );
};

export default HomeSvg;
